import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { AutoCapitalizePipe, IconType } from '@kinomap-dev/ng-ui-lib/core';
import { ColorService } from '../../services/color.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-chip',
  imports: [IconComponent, TranslateModule, AutoCapitalizePipe],
  template: `
    <kin-icon [name]="icon()" [color]="iconColor() ?? color()" [size]="20" />
    @if (formatText()) {
      <span>{{ text() | translate | autoCapitalize }}</span>
    } @else {
      <span>{{ text() | translate }}</span>
    }
  `,
  styleUrl: './chip.scss',
  host: {
    '[class.crossed]': 'isCrossedOut()',
    '[style.backgroundColor]': 'backgroundColor()',
    '[style.borderColor]': 'borderColor()',
    '[style.color]': 'color()',
    '[style.--iconBackground]': 'iconBackground()',
  },
})
export class Chip {
  public colorService: ColorService = inject(ColorService);

  text: InputSignal<string> = input.required();
  icon: InputSignal<IconType> = input.required();
  isCrossedOut: InputSignal<boolean> = input<boolean>(false);
  formatText: InputSignal<boolean> = input<boolean>(true);
  backgroundColor: InputSignal<string> = input<string>(this.colorService.backgroundColor());
  color: InputSignal<string> = input<string>(this.colorService.neutral600());

  borderColor: InputSignal<string | undefined> = input<string | undefined>(undefined);
  iconColor: InputSignal<string | undefined> = input<string | undefined>(undefined);
  iconBackground: InputSignal<string | undefined> = input<string | undefined>(undefined);
}
